import React from "react";
import { connect } from "react-redux";
// Nâng cấp từ Material-UI v4 lên MUI v5
import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

// Sử dụng styled API thay cho makeStyles
const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: 99999,
    color: "#fff",
}));

function LoadingScreen(props) {
    return (
        <StyledBackdrop open={props.loadingQueue.length > 0}>
            <CircularProgress color="inherit" />
        </StyledBackdrop>
    );
}

const mapStateToProps = (state) => ({
    loadingQueue: state.loadingState.loadingQueue,
});

export default connect(mapStateToProps)(LoadingScreen);
